module.exports = __webpack_public_path__ + "img/minus_btn.711d47a8.png";